<template>
  <div class='previewDueTime'>
    <div>创建时间：{{scope.row.formatCreateTime}}</div>
    <div>到期时间：{{scope.row.formatExpirationTime}}</div>
    <div>结算到期时间：{{formatTime(scope.row.settleExpirationTime)}}</div>
    <div>退单前到期时间：{{formatTime(scope.row.beforeChargebackExpirationTime)}}</div>
    <div>最新续费时间：{{formatTime(scope.row.latestRenewTime)}}</div>
  </div>
</template>

<script>
export default {
  name: 'previewDueTime',
  props: {
    tableData: Object,
    scope: Object
  },
  methods: {
    formatTime (time) {
      if (time) return time.split(' ')[0]
      else return '-'
    }
  }
}
</script>
